import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollPositions = new Map();

function saveScrollPosition(key) {
  const y = window.scrollY;
  scrollPositions.set(key, y);
  console.log(`[ScrollRestoration] saved scroll for ${key}: ${y}`);
}

export function ScrollRestoration({ children }) {
  const location = useLocation();
  const key = location.pathname + location.search + location.hash;

  // Save scroll position on mount
  useEffect(() => {
    saveScrollPosition(key);
    return () => {
      console.log(`[ScrollRestoration] cleanup for ${key}`);
    };
  }, [key]);

  // Restore scroll position on navigation
  useEffect(() => {
    const stored = scrollPositions.get(key);
    if (stored != null) {
      window.scrollTo(0, stored);
      console.log(`[ScrollRestoration] restored scroll for ${key}: ${stored}`);
    } else {
      window.scrollTo(0, 0);
      console.log(`[ScrollRestoration] default scroll top for ${key}`);
    }
  }, [key]);

  return children;
}
